import { defineMessages } from "react-intl";

const messages = defineMessages({
  acitivities: {
    id: "settings.manageFields.tabs.activities",
    defaultMessage: "Activities",
    description: "Title of organization details general tab",
  },
  addCustomField: {
    id: "settings.manageFields.actions.addCustomField",
    defaultMessage: "+ Add Custom Field",
    description: "Title of Add Custom Field button",
  },
  archive: {
    id: "settings.manageFields.archive",
    defaultMessage: "Archive",
    description: "Button for archiving fields",
  },
  backToArchived: {
    id: "settings.manageFields.actions.backToArchived",
    defaultMessage: "Back to active fields",
    description: "Title of Back to active fields button",
  },
  cancelButton: {
    id: "settings.manageFields.popConfirm.cancelButton",
    defaultMessage: "Cancel",
    description: "cancel button of pop confirm",
  },
  checkBoxMessage: {
    id: "settings.manageFields.checkBoxMessage",
    defaultMessage: "{count} {count, plural, one {field} other {fields}} selected",
    description: "Message for selected fields",
  },
  companies: {
    id: "settings.manageFields.tabs.companies",
    defaultMessage: "Companies",
    description: "Title of organization details general tab",
  },
  deals: {
    id: "settings.manageFields.tabs.deals",
    defaultMessage: "Deals",
    description: "Title of organization details general tab",
  },
  editFieldAccessButton: {
    id: "settings.manageFields.editFieldAccessButton",
    defaultMessage: "Edit Field Access",
    description: "Button for bulk editing field access",
  },
  okButton: {
    id: "settings.manageFields.popConfirm.okButton",
    defaultMessage: "Archive Fields",
    description: "ok button of pop confirm",
  },
  people: {
    id: "settings.manageFields.tabs.people",
    defaultMessage: "People",
    description: "Title of organization details general tab",
  },
  phiAlert: {
    id: "settings.manageFields.phiAlert",
    defaultMessage:
      "Protected Health Information (PHI) options are now available for individual fields.",
    description: "PHI promotion alert",
  },
  placeholder: {
    id: "settings.manageFields.search.placeholder",
    defaultMessage: "Search",
    description: "Placeholder for search field",
  },
  popConfirmDescription: {
    id: "settings.manageFields.popConfirm.description",
    defaultMessage: "If one of the selected fields cannot be archived, it will not be updated.",
    description: "Content of pop confirm",
  },
  popConfirmTitle: {
    id: "settings.manageFields.popConfirm.title",
    defaultMessage: "Do you want to archive the selected fields?",
    description: "Title of pop confirm",
  },

  title: {
    id: "settings.manageFields.title",
    defaultMessage: "Manage Fields",
    description: "Title of settings manage fields page",
  },
  unarchive: {
    id: "settings.manageFields.unarchive",
    defaultMessage: "Unarchive",
    description: "Button for unarchiving fields",
  },
  viewArchived: {
    id: "settings.manageFields.actions.viewArchived",
    defaultMessage: "View archived fields",
    description: "Title of View archived fields button",
  },
});

export default messages;
